exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "h1#proy-code[data-v-b56c0894]{margin-top:0}.tab-container[data-v-b56c0894]{padding-top:20px}", "", {"version":3,"sources":["D:/laragon/www/sima/simaapp-web/src/components/views/reportes-media/index.vue"],"names":[],"mappings":"AACA,8BACE,YAAc,CACf,AACD,gCACE,gBAAiB,CAClB","file":"index.vue","sourcesContent":["\nh1#proy-code[data-v-b56c0894] {\n  margin-top: 0;\n}\n.tab-container[data-v-b56c0894]{\n  padding-top: 20px\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b56c0894","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/reportes-media/index.vue
// module id = 375
// module chunks = 0